<script>
export default {
  props: {
    size: { type: String, default: 'lg' },
    imageUrl: { type: String, default: null },
  },
  data: () => ({ configuration: {} }),
  computed: {
    resolvedImageUrl() { return this.imageUrl || this.configuration.system_logo || '/images/aai_logo_new.png'; },
    altText() { return this.configuration.app_name || 'Application logo'; },
  },
  mounted() { this.refreshConfiguration(); window.addEventListener('app:system-configuration-updated', this.onConfigurationUpdated); },
  beforeUnmount() { window.removeEventListener('app:system-configuration-updated', this.onConfigurationUpdated); },
  methods: {
    refreshConfiguration() { try { this.configuration = JSON.parse(localStorage.getItem('systemConfiguration') || '{}'); } catch { this.configuration = {}; } },
    onConfigurationUpdated(event) { this.configuration = event.detail || {}; },
  },
};
</script>
<template><img :src="resolvedImageUrl" :alt="altText" :style="'height:' + (size === 'sm' ? '18' : '40') + 'px;'" /></template>
